import React from "react";
import { useTranslation } from "react-i18next";
import { Alert, Card, Row, Col } from "react-bootstrap";
import DashboardStatBox from "./DashboardStatBox";

const AdminTodayView = ({ data }) => {
  const { t } = useTranslation();
  const d = data;

  return (
    <>
      <p className="text-muted small mb-3">
        <i className="bi bi-clock me-1" />
        {t("app.analytics.todayTabDescription")}
      </p>
      <Card className="shadow-sm border-0 mb-4 analytics-card">
        <Card.Header className="bg-light border-0 py-2 px-2 px-md-3">
          <span className="fw-semibold text-secondary small text-uppercase">
            <i className="bi bi-building me-2" />
            {t("app.analytics.organizationSnapshot")}
          </span>
        </Card.Header>
        <Card.Body className="pt-2 pb-3 px-2 px-md-3">
          <Row className="g-2 g-md-3">
            <DashboardStatBox value={d.totalWorkplaces} label={t("app.analytics.totalWorkplaces")} icon="bi-building" iconColor="#FFA726" background="rgba(255, 167, 38, 0.08)" md={4} />
            <DashboardStatBox value={d.totalDepartments} label={t("app.analytics.totalDepartments")} icon="bi-diagram-3-fill" iconColor="#4ECDC4" background="rgba(78, 205, 196, 0.08)" md={4} />
            <DashboardStatBox value={d.totalUsers} label={t("app.analytics.totalUsers")} icon="bi-person-check-fill" iconColor="#66BB6A" background="rgba(102, 187, 106, 0.08)" md={4} />
            <DashboardStatBox value={d.totalLeaveTypes} label={t("app.analytics.leaveTypes")} icon="bi-tag-fill" iconColor="#4A90E2" background="rgba(74, 144, 226, 0.08)" md={4} />
            <DashboardStatBox value={d.totalTeams} label={t("app.analytics.totalTeams")} icon="bi-people-fill" iconColor="#4ECDC4" background="rgba(78, 205, 196, 0.08)" md={4} />
            <DashboardStatBox value={d.totalProjects} label={t("app.analytics.totalProjects")} icon="bi-kanban" iconColor="#BA68C8" background="rgba(186, 104, 200, 0.08)" md={4} />
            <DashboardStatBox value={d.totalEmploymentTypes} label={t("app.analytics.totalEmploymentTypes")} icon="bi-briefcase" iconColor="#4DD0E1" background="rgba(77, 208, 225, 0.08)" md={4} />
            <DashboardStatBox value={d.totalDesignations} label={t("app.analytics.totalDesignations")} icon="bi-award" iconColor="#FFD54F" background="rgba(255, 213, 79, 0.08)" md={4} />
          </Row>
        </Card.Body>
      </Card>
      <Card className="shadow-sm border-0 mb-4 analytics-card border-start border-4 border-success">
        <Card.Header className="bg-light border-0 py-2 px-2 px-md-3">
          <span className="fw-semibold text-secondary small text-uppercase">
            <i className="bi bi-activity me-2" />
            {t("app.analytics.activityToday")}
          </span>
        </Card.Header>
        <Card.Body className="pt-2 pb-3 px-2 px-md-3">
          <Row className="g-2 g-md-3">
            <DashboardStatBox value={d.peoplePresentToday} label={t("app.analytics.peoplePresentToday")} icon="bi-person-check" iconColor="#66BB6A" background="rgba(102, 187, 106, 0.08)" md={4} />
            <DashboardStatBox value={d.documentsUploadedToday} label={t("app.analytics.documentsUploadedToday")} icon="bi-file-earmark-plus" iconColor="#4A90E2" background="rgba(74, 144, 226, 0.08)" md={4} />
            <DashboardStatBox value={d.timesheetsSubmittedToday} label={t("app.analytics.timesheetsSubmittedToday")} icon="bi-clock-history" iconColor="#FFA726" background="rgba(255, 167, 38, 0.08)" md={4} />
            <DashboardStatBox value={d.totalDocumentsUploaded} label={t("app.analytics.totalDocumentsUploaded")} icon="bi-file-earmark-arrow-up" iconColor="#E57373" background="rgba(229, 115, 115, 0.08)" md={4} />
          </Row>
        </Card.Body>
      </Card>
      <Card className="shadow-sm border-0 mb-4 analytics-card border-start border-4 border-warning">
        <Card.Header className="bg-light border-0 py-2 px-2 px-md-3">
          <span className="fw-semibold text-secondary small text-uppercase">
            <i className="bi bi-calendar-day me-2" />
            {t("app.analytics.leaveToday")}
          </span>
        </Card.Header>
        <Card.Body className="pt-2 pb-3 px-2 px-md-3">
          <Row className="g-2 g-md-3">
            <DashboardStatBox value={d.personsOnLeaveToday} label={t("app.analytics.personsOnLeaveToday")} icon="bi-calendar-x-fill" iconColor="#E57373" background="rgba(229, 115, 115, 0.08)" md={4} />
            <DashboardStatBox value={d.leaveRequestsToday} label={t("app.analytics.leaveRequestsToday")} icon="bi-calendar2-event" iconColor="#FFD54F" background="rgba(255, 213, 79, 0.08)" md={4} />
            <DashboardStatBox value={d.pendingLeaveRequestsToday} label={t("app.analytics.pendingLeaveRequestsToday")} icon="bi-hourglass-split" iconColor="#FFA726" background="rgba(255, 167, 38, 0.08)" md={4} />
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

const ManagerTodayView = ({ data }) => {
  const { t } = useTranslation();

  return (
    <>
      <p className="text-muted small mb-3">{t("app.analytics.todayTabDescriptionManager")}</p>
      <Card className="shadow-sm border-0 mb-4 analytics-card">
        <Card.Body className="py-4 px-3 text-center">
          <i className="bi bi-people fs-1 text-primary mb-3 d-block" />
          <h4 className="fw-bold mb-1">{data.teamMemberCount}</h4>
          <p className="text-muted mb-0">{t("app.analytics.teamMemberCount")}</p>
          <p className="text-muted small mt-3 mb-0">{t("app.analytics.todayManagerHint")}</p>
        </Card.Body>
      </Card>
    </>
  );
};

const UserTodayView = ({ data }) => {
  const { t } = useTranslation();

  return (
    <>
      <p className="text-muted small mb-3">{t("app.analytics.todayTabDescription")}</p>
      {data.isOnLeaveToday ? (
        <Alert variant="warning" className="d-flex align-items-center mb-4 border-0 shadow-sm">
          <i className="bi bi-calendar-x-fill me-3 fs-3" />
          <div>
            <strong className="d-block">{t("app.analytics.onLeaveTodayBanner")}</strong>
            <span className="small">{t("app.analytics.onLeaveTodayDetail")}</span>
          </div>
        </Alert>
      ) : (
        <Alert variant="success" className="d-flex align-items-center mb-4 border-0 shadow-sm">
          <i className="bi bi-check-circle-fill me-3 fs-4" />
          <strong>{t("app.analytics.notOnLeaveToday")}</strong>
        </Alert>
      )}
      <Row className="g-3">
        <Col xs={12} sm={6}>
          <Card className="shadow-sm border-0 h-100 text-center py-4">
            <Card.Body>
              <i className="bi bi-kanban fs-2 text-primary mb-2 d-block" />
              <h3 className="fw-bold mb-0">{data.assignedProjects}</h3>
              <span className="text-muted small">{t("app.analytics.assignedProjects")}</span>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} sm={6}>
          <Card className="shadow-sm border-0 h-100 text-center py-4">
            <Card.Body>
              <i className="bi bi-people fs-2 text-info mb-2 d-block" />
              <h3 className="fw-bold mb-0">{data.teamCount}</h3>
              <span className="text-muted small">{t("app.analytics.teamCount")}</span>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

const TodayDashboardView = ({ data, roleType }) => {
  if (!data) return null;
  if (roleType === "admin") return <AdminTodayView data={data} />;
  if (roleType === "manager") return <ManagerTodayView data={data} />;
  return <UserTodayView data={data} />;
};

export default TodayDashboardView;
